module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Katherine Deauxville\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Katherine Deauxville is the author of twenty-five published novels, including "), _c('I', [_vm._v("A Christmas Romance")]), _vm._v(" (writing as Maggie Daniels), which was featured in "), _c('I', [_vm._v("Good Housekeeping")]), _vm._v(" magazine and aired as top-rated CBS Sunday Night Movie in 1994. Other bestselling romances include "), _c('I', [_vm._v("Blood Red Roses")]), _vm._v(", "), _c('I', [_vm._v("Daggers of Gold")]), _vm._v(", "), _c('I', [_vm._v("The Amethyst Crown")]), _vm._v(", "), _c('I', [_vm._v("The Crystal Heart")]), _vm._v(", and "), _c('I', [_vm._v("Eyes of Love")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/13EuEfk/images/cover.jpg?1733067619887",
      "alt": "This image is the cover for the book Blood Red Roses"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Blood Red Roses\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Medieval England springs to life in a romance that “transcends its basic formula with a convincing setting integral to the tale and believable characters” ("), _c('i', [_vm._v("Publishers Weekly")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v(" Fulk de Jobourgh is a knight of the court of King William, commanded to oversee the lands of a noble who was hanged for treason. He is also instructed to marry the dead traitor’s rebellious daughter and ensure her loyalty to the king. He brings her to the altar, and to his bed, before galloping off once again to command in the King’s war. Although Alwyn, his unwilling bride, is barely able to remember the face of Fulk, she cannot forget her response to his touch. At every turn, she thwarts his efforts to take control of her father’s estate and finds herself enslaved by her passion for him. Will she be able to resist the sensual pleasure of his touch in order to save her rightful legacy and family honor?\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0